export default {"src":"/_next/static/media/rewards-ll-logo-blue.26d4c120.svg","height":86,"width":223,"blurWidth":0,"blurHeight":0};